import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}
console.log('START BOOTSTRAP');

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .then(() => console.log('BOOTSTRAP SUCCESS'))
  .catch(err => {
    console.error('BOOTSTRAP FAILED ❌', err);
  });